import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import ShareViewer from './pages/ShareViewer';
import { ProProvider } from './hooks/useProStatus';
import { UpgradeModal } from './components/settings/UpgradeModal';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ProProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/app" element={<App />} />
          <Route path="/app.html" element={<App />} />
          <Route path="/share/:shareId" element={<ShareViewer />} />
        </Routes>
      </BrowserRouter>
      <UpgradeModal />
    </ProProvider>
  </React.StrictMode>
);
